import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'totalAmount',
  standalone: false
})
export class TotalAmountPipe implements PipeTransform {

  transform(values: Array<any>, fields: string[]): number {
    return values
      .map(value => fields.reduce((obj, key) =>
        (obj && obj[key] !== 'undefined') ? obj[key] : undefined, value as number))
      .reduce((sum, value) => sum + value, 0);
  }

}
